import { defineStore } from 'pinia'
import { articleService } from '@/services/articleService'
import errorService from '@/services/errorService'

export const useArticleStore = defineStore('article', {
  state: () => ({
    allArticles: {
      data: {},
      meta: {},
      categories: {}
    },
    articles: {
      data: {},
      meta: {}
    },
    articlesRequests: {
      data: {},
      meta: {}
    },
    articleRequest: {
      data: {},
      meta: {}
    },
    stepArticles: {
      data: {},
      meta: {}
    },
    articlesLinks: {
      meta: {},
      data: {},
    },
    articlesTopLinks: {
      meta: {},
      data: {},
    },
    article: {
      meta: {
        references: []
      },
    },
    images: {},
    filter: {
      site: null,
      category: null,
      order_by: 'recent',
    },
  }),

  actions: {
    async getShareArticles(params, cancelToken) {
      try {
        const response = await articleService.fetchShareArticles(params, cancelToken);
        this.allArticles = response.data;

        return { success: true };
        
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getArticlesLinks(cancelToken) {
      try {
        const response = await articleService.fetchArticlesLinks(this.filter, cancelToken);
        this.articlesLinks = response.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getArticlesTopLinks(cancelToken) {
      try {
        const response = await articleService.fetchArticlesTopLinks({}, cancelToken);
        this.articlesTopLinks = response.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getArticles(cancelToken) {
      try {
        const response = await articleService.fetchArticles(this.filter, cancelToken);
        this.articles = response.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getStepArticles(cancelToken) {
      try {
        const response = await articleService.fetchStepArticles(this.filter, cancelToken);
        this.stepArticles = response.data;

        return { success: true };

      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getArticle(id) {
    try {
        const response = await articleService.fetchArticle(id);
        this.article = response.data.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getShareArticle(id) {
      try {
        const response = await articleService.fetchShareArticle(id);
        return { success: true, data: response.data.data };
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async addArticle(params) {
      try {
        await articleService.createArticle(params);
        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async updateArticle(id, params) {
      try {
        await articleService.updateArticle(id, params);
        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async uploadAttachment(params) {
      try {
        let result = await articleService.uploadAttachment(params);
        return { success: true, image: result.data };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async generateUrl(params){
      try {
        await articleService.generateUrl(params);
        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async reportArticle(id, params){
      try {
        await articleService.reportArticle(id, params);
        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async searchImages(params, cancelToken) {
      try {
          const response = await articleService.searchImages(params, cancelToken);
          this.images = response.data;
          return { success: true };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },

      async checkArticle(params) {
        try {
          let result = await articleService.checkArticle(params);
          return { success: true, sentences: result.data.sentences };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },

      async getArticlesRequests() {
        try {
          const response = await articleService.fetchArticlesRequests(this.filter);
          this.articlesRequests = response.data;
        } catch (error) {
          return errorService.handle(error);
        }
      },

      async getArticleRequest(id) {
        try {
            const response = await articleService.fetchArticleRequest(id);
            this.articleRequest = response.data.data;
          } catch (error) {
            return errorService.handle(error);
          }
      },

      async createArticleRequest(params) {
        try {
          await articleService.createArticleRequest(params);
          return { success: true };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },

      async updateArticleRequest(id, params) {
        try {
          await articleService.updateArticleRequest(id, params);
          return { success: true };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },

      async catchArticleRequest(id) {
        try {
          await articleService.catchArticleRequest(id);
          return { success: true };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },

      async generateArticle(params) {
        try {
          let result = await articleService.generateArticle(params);
          return { success: true, article: result.data.article };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },

      async generateTitles(id) {
        try {
          let result = await articleService.generateTitles(id);
          return { success: true, titles: result.data.titles };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },
  },
});